export class AddRecipientToCartRequest {
    public name: string;
    public department: string;
    public phoneNumber: string;
    public ticketCount: number;
    public groupTicket: boolean;
    public countryCode: string;
    public id: string;

    constructor(name: string, department: string, phoneNumber: string,
                countryCode: string, ticketCount: number, groupTicket: boolean, id: string) {
        this.name = name;
        this.department = department;
        this.phoneNumber = phoneNumber;
        this.ticketCount = ticketCount;
        this.groupTicket = groupTicket;
        this.countryCode = countryCode;
        this.id = id;
    }
}
